const hopeLink = slug => {
  return slug.split('pga-hope-')[1]
}

export const academyLink = academy => {
  const isHopeAcademy = academy.slug.startsWith('pga-hope')

  const linkPrefix = isHopeAcademy ? 'pga-hope' : 'academies'
  const slug = isHopeAcademy ? hopeLink(academy.slug) : academy.slug

  return `${linkPrefix}/${slug}`
}

export const formatCoachRole = role =>
  (role || '').replace(
    /(\w)(\w*)/g,
    (_, firstChar, rest) => firstChar + rest.toLowerCase(),
  )

const compareStrings = (left, right, dir) => {
  if (left > right) return dir === 'desc' ? -1 : 1
  if (left < right) return dir === 'desc' ? 1 : -1
  return 0
}

export const matchesCoachSearchTerm = (employment, term) => {
  const normalizedTerm = term.toLowerCase().trim()
  if (!normalizedTerm) return true

  const searchableFields = [
    employment.coach?.name,
    employment.coach?.email,
    formatCoachRole(employment.role),
    employment.role,
  ]

  return searchableFields.some(field =>
    field?.toLowerCase().includes(normalizedTerm),
  )
}

export const sortByCoachName = (a, b, dir) => {
  const left = (a.props.employment?.coach?.name || '')
    .toLowerCase()
    .replace(/\s/g, '')
  const right = (b.props.employment?.coach?.name || '')
    .toLowerCase()
    .replace(/\s/g, '')

  return compareStrings(left, right, dir)
}

export const sortByCoachRole = (a, b, dir) => {
  const left = (a.props.employment?.role || '').toLowerCase()
  const right = (b.props.employment?.role || '').toLowerCase()

  return compareStrings(left, right, dir)
}

export const sortByCoachEmail = (a, b, dir) => {
  const left = (a.props.employment?.coach?.email || '').toLowerCase()
  const right = (b.props.employment?.coach?.email || '').toLowerCase()

  return compareStrings(left, right, dir)
}
